import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" height={props.height || 20} width={props.width || 21} viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M222.154-180.001l-42.153-42.153L637.847-680H360v-59.999h379.999V-360H680v-277.847L222.154-180.001z"></path>
    </svg>;
}
export default Icon;